import {
  Area,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatINRCompact, formatPeriodLabel } from '../../utils/formatters';

export function CashFlowChart({ series }) {
  const data = (series || []).map((s) => ({
    ...s,
    label: formatPeriodLabel(s.period),
  }));

  if (!data.length) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-800">Cash flow (Contra excluded)</h3>
      <div className="h-72 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-slate-200" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
            <Tooltip formatter={(v) => formatINRCompact(v)} />
            <Legend />
            <Area
              type="monotone"
              dataKey="inflows"
              name="Inflows"
              stroke="#10b981"
              fill="#10b981"
              fillOpacity={0.25}
            />
            <Area
              type="monotone"
              dataKey="outflows"
              name="Outflows"
              stroke="#ef4444"
              fill="#ef4444"
              fillOpacity={0.2}
            />
            <Line type="monotone" dataKey="net" name="Net" stroke="#0f172a" strokeWidth={2} dot />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
